import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function LeaguesRedirectScreen() {
  const { ownerId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (ownerId) {
      localStorage.setItem('tournamentOwner', ownerId);
    }
    navigate('/');
  }, [ownerId, navigate]);

  return null;
}

export default LeaguesRedirectScreen;
